<template>
  <BaseLayout title="Payments Log">
    <PaymentsPaypointStatistics ref="statisticsRef" />
    <PaymentsLog @action-success="handlePaymentActionSuccess" />
  </BaseLayout>
</template>

<script setup lang="ts">
import { ref } from "vue";
import BaseLayout from "@/shared/components/BaseLayout.vue";

import PaymentsPaypointStatistics from "@/modules/payments/components/PaymentsLogPaypointStatistics.vue";
import PaymentsLog from "@/modules/payments/components/PaymentsLog.vue";

const statisticsRef = ref<InstanceType<
  typeof PaymentsPaypointStatistics
> | null>(null);

const handlePaymentActionSuccess = () => {
  statisticsRef.value?.refreshStatistics();
};
</script>
